interface imagesPropType {
  url: string;
  alt: string;
}

interface extractSelectedImagesPropTypes {
  images: imagesPropType[];
  indexes?: number[];
}

export default function extractSelectedImages({
  images,
  indexes,
}: extractSelectedImagesPropTypes): imagesPropType[] {
  return images.filter((_, index) => indexes.includes(index));
}
